export class PurchaseOptions {
    constructor(offerId, applyOffer, oldProduct, updatePolicy, contextKeys, quantity, promotionalOffer) {
        this.offerId = offerId;
        this.applyOffer = applyOffer;
        this.oldProduct = oldProduct;
        this.updatePolicy = updatePolicy;
        this.contextKeys = contextKeys;
        this.quantity = quantity;
        this.promotionalOffer = promotionalOffer;
    }
}
//# sourceMappingURL=PurchaseOptions.js.map